/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EditNewslettersInput = {
    readonly userServiceId: string;
    readonly emailToken?: string | null;
    readonly promotional?: boolean | null;
    readonly favoriteSearches?: boolean | null;
    readonly favoriteDealers?: boolean | null;
    readonly trade?: boolean | null;
    readonly smsOptin?: boolean | null;
    readonly orderFeedbackMailOptin?: boolean | null;
    readonly clientMutationId?: string | null;
};
export type subscribeUserMutationVariables = {
    input: EditNewslettersInput;
};
export type subscribeUserMutationResponse = {
    readonly editNewsletters: {
        readonly clientMutationId: string | null;
    } | null;
};
export type subscribeUserMutation = {
    readonly response: subscribeUserMutationResponse;
    readonly variables: subscribeUserMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EditNewslettersInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "editNewsletters",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EditNewslettersPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "subscribeUserMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "subscribeUserMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "subscribeUserMutation",
    "id": "ferrum/246.0.0-2020-01-07T17:04:52.253Z/subscribeUserMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'c9543e77c781df16904396e3a1064187';
export default node;
